import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetch_shop_food, fetch_shop_pharmacy, fetch_shop_product } from './api';
import type { ShopQuery } from './types';

export function use_shop_food(query: ShopQuery, enabled = true) {
  return useQuery({
    queryKey: ['shop-food', query],
    queryFn: () => fetch_shop_food(query),
    placeholderData: keepPreviousData,
    enabled,
  });
}

export function use_shop_pharmacy(query: ShopQuery, enabled = true) {
  return useQuery({
    queryKey: ['shop-pharmacy', query],
    queryFn: () => fetch_shop_pharmacy(query),
    placeholderData: keepPreviousData,
    enabled,
  });
}

export function use_shop_product(vertical: 'food' | 'pharmacy', id: string | undefined) {
  return useQuery({
    queryKey: ['shop-product', vertical, id],
    queryFn: () => fetch_shop_product(vertical, id as string),
    enabled: !!id,
  });
}
